export const APPS = [
  { slug: "spendle", name: "Spendle" },
  { slug: "single-focus", name: "Single Focus" },
  { slug: "wheel-of-life", name: "Wheel of Life" },
];

export function findAppBySlug(slug) {
  return APPS.find((a) => a.slug === slug) || null;
}
